import apiService from './api';
import type { ApiResponse } from '../types';
import type { BasSummary } from '../types/bas';

/** The month's BAS summary. Any accounts seat. */
class BasService {
  // Several Xero reads behind one request; the default 10s is not enough.
  async getMonth(month: string): Promise<ApiResponse<BasSummary>> {
    return apiService.get(`/accounts/bas?month=${encodeURIComponent(month)}`, { timeout: 90_000 });
  }
}

export default new BasService();
